import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatDate } from 'shared/src/date-string-utils/date-utils';
import { ISODateString } from 'shared/src/date-string-utils/types';
import { faCalendarDays, faEye } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';

export function RightRailSubheading({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded bg-gray-200 px-2 py-1 text-sm font-semibold text-gray-800">
      {children}
    </div>
  );
}

export function RightRailSection({ children }: { children: React.ReactNode }) {
  return <div className="flex justify-between gap-0.5">{children}</div>;
}

type RightRailItemProps = {
  label: string;
  value: string | React.ReactNode | null | undefined;
  cta?: React.ReactNode;
};

export function RightRailItem({ label, value, cta }: RightRailItemProps) {
  return (
    <div className="flex flex-1 justify-between rounded-sm bg-white px-2 py-2">
      <div className="flex flex-col justify-end">
        <div className="text-sm font-semibold">{value || '-'}</div>
        <div className="text-xs font-light text-gray-500">{label}</div>
      </div>
      {cta}
    </div>
  );
}

export function ValueEmphasis({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={clsx(
        'rounded-xl bg-[#111928] px-2 py-1 text-center text-xs font-normal leading-[20px] text-white',
        className
      )}>
      {children}
    </span>
  );
}

export function ValueWithSubvalue({
  value,
  showSubvalue,
  subvalue
}: {
  value: string;
  showSubvalue: boolean;
  subvalue: string;
}) {
  return (
    <span className="flex gap-1">
      {value}
      {showSubvalue && (
        <span className="border-l border-gray-500 pl-1 font-normal text-gray-500">{subvalue}</span>
      )}
    </span>
  );
}

export function ViewPacingSchedule({ openPacing }: { openPacing: () => void }) {
  return (
    <div
      className="flex cursor-pointer items-center self-center rounded-sm bg-blue-600 px-2 py-[2px] text-sm font-light text-white"
      onClick={openPacing}>
      <FontAwesomeIcon icon={faEye} className="mr-1" />
      <div>View Pacing Schedule</div>
    </div>
  );
}

export function DateItem({
  label,
  date
}: {
  label: string;
  date: ISODateString | null | undefined;
}) {
  return (
    <div className="rounded bg-white px-2 py-2">
      <FontAwesomeIcon className="text-gray-500" icon={faCalendarDays} />
      <div className="text-sm font-bold">{date ? formatDate(date, 'MM/dd/yyyy') : '-'}</div>
      <div className="text-xs font-light text-gray-500">{label}</div>
    </div>
  );
}
